import { BarElement, Chart as ChartJS, Tooltip } from 'chart.js';
import React from 'react';
import { Bar } from 'react-chartjs-2';

ChartJS.register(BarElement, Tooltip);

interface ActiveSubscribersChartProps {
  labels: string[];
  data: number[];
}

const ActiveSubscribersChart = ({ labels, data }: ActiveSubscribersChartProps) => {
  if (data.length === 0) {
    return null;
  }

  return (
    <section className="mt-28 border-0 border-t border-solid border-t-grayscale-beige pt-28">
      <h3 className="m-0 mb-20 text-center font-suisse-intl-mono text-overline-md text-black">
        Active subscribers, last four months
      </h3>
      <Bar
        data={{
          labels,
          datasets: [
            {
              data,
              backgroundColor: 'rgb(243 42 82)',
              hoverBackgroundColor: 'rgb(254 198 204)',
            },
          ],
        }}
        options={{
          responsive: true,
          plugins: {
            legend: {
              display: false,
            },
          },
        }}
      />
    </section>
  );
};

export default ActiveSubscribersChart;
